import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import './index.scss';

// FIXME we should not really be grabbing stuff from the
// Window in a React component. Proxy required
if (window.L && window.L.mapbox) {
  window.L.mapbox.accessToken = window.settings.keys.mapbox;
}

export default class MapboxMap extends React.PureComponent {
  static propTypes = {
    children: PropTypes.any,
    defaultLatitude: PropTypes.number,
    defaultLongitude: PropTypes.number,
    defaultZoom: PropTypes.number,
    height: PropTypes.number.isRequired,
    onLoad: PropTypes.func.isRequired,
    onMove: PropTypes.func,
  };

  state = {
    mapboxMap: null,
  };

  componentDidMount() {
    // World coordinates. These bounds will prevent user from scrolling
    // Outside of the marker area
    const southWest = L.latLng(-90, -180);
    const northEast = L.latLng(90, 180);
    const bounds = L.latLngBounds(southWest, northEast);

    const map = L.mapbox.map(this._node, '', {
      // Removes attribution from interactive map
      attributionControl: false,
      maxBounds: bounds,
      minZoom: 2,
    });

    L.mapbox
      .styleLayer('mapbox://styles/tgeer/cio4ici1z007ub5ni1rdeh2uo', {
        // Removes attribution from interactive map
        attributionControl: false,
        // This map option disables world wrapping
        continuousWorld: false,
        // This option enables loading tiles outside of the world bounds.
        noWrap: false,
      })
      .addTo(map);

    map.scrollWheelZoom.disable();

    this.setState({mapboxMap: map});

    if (this.props.defaultLatitude && this.props.defaultLongitude) {
      map.setView(
        [this.props.defaultLatitude, this.props.defaultLongitude],
        this.props.defaultZoom !== undefined ? this.props.defaultZoom : 12,
      );
    }

    setTimeout(() => {
      map.on('dragend', this.props.onMove);
      map.on('zoomend', this.props.onMove);
    }, 0);

    // Tell parent component that the Leaflet map has been initialized
    this.props.onLoad();
  }

  /**
   * This component uses context to pass a reference to the Leaflet map to
   * child componenents, like markers, which need it in order to render.
   * Child components do not render unless the map exists
   */
  render() {
    return (
      <div
        ref={(node) => (this._node = node)}
        style={{
          height: this.props.height,
          overflow: 'hidden',
          width: '100%',
        }}>
        {this.state.mapboxMap
          ? React.Children.map(this.props.children, (child) => {
              return React.cloneElement(child, {
                mapboxMap: this.state.mapboxMap,
              });
            })
          : null}
      </div>
    );
  }
}
